/**
 * Date utilities for handling consistent date formats and display
 */

import { format } from 'date-fns'

/**
 * Creates a date object from a date string, correctly handling
 * both UTC dates (with Z) and local dates (without Z)
 */
export const parseDate = (dateString: string): Date => {
  if (!dateString) {
    return new Date()
  }

  try {
    // Check if the date string has a 'Z' suffix (UTC)
    if (dateString.includes('Z')) {
      // Parse the UTC time components from the string
      const [datePart, timePart] = dateString.split('T')
      const [year, month, day] = datePart.split('-').map(Number)

      // Clean up the time part by removing Z and milliseconds
      const cleanTimePart = timePart.split('.')[0]
      const [hours, minutes, seconds] = cleanTimePart.split(':').map(Number)

      // Create a new date with local time interpretation
      return new Date(year, month - 1, day, hours, minutes, seconds || 0)
    }

    // For dates without Z, use standard constructor
    return new Date(dateString)
  } catch (error) {
    console.error('Error parsing date:', error)
    return new Date()
  }
}

/**
 * Creates a date string in local time format without timezone information
 */
export const createUpdatedDate = (): string => {
  return format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
}
